import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye } from "lucide-react";

const visitor = () => {
  let v = localStorage.getItem("cap_vid");
  if (!v) { v = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`; localStorage.setItem("cap_vid", v); }
  return v;
};

// Counts one visit per person/car/day; admin's own visits are skipped
export const trackView = (kind, car_id) => {
  if (!car_id || localStorage.getItem("an_token")) return;
  api.post("/track/view", { kind, car_id, visitor: visitor() }).catch(() => {});
};

export const useCarViews = (kind) => {
  const [views, setViews] = useState({});
  useEffect(() => { api.get(`/admin/views/${kind}`).then((r) => setViews(r.data)).catch(() => {}); }, [kind]);
  return views;
};

export const sortByViews = (cars, views, on) => (on ? [...cars].sort((a, b) => (views[b.id]?.d30 || 0) - (views[a.id]?.d30 || 0)) : cars);

export const ViewsBadge = ({ v, id }) => (
  <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground mt-2" data-testid={`views-${id}`}>
    <Eye className="w-3.5 h-3.5 text-[#3B82F6]" />
    <span>Visite: oggi <b className="text-white" data-testid={`views-${id}-today`}>{v?.today || 0}</b> · 7 gg <b className="text-white" data-testid={`views-${id}-d7`}>{v?.d7 || 0}</b> · 30 gg <b className="text-white" data-testid={`views-${id}-d30`}>{v?.d30 || 0}</b></span>
  </div>
);

export const SortByViewsToggle = ({ on, setOn, id }) => (
  <button onClick={() => setOn(!on)} data-testid={`${id}-sort-views`}
    className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm transition-colors ${on ? "bg-white text-black border-white font-semibold" : "border-white/15 text-muted-foreground hover:text-white"}`}>
    <Eye className="w-4 h-4" />Più viste (30 gg)
  </button>
);
